import {useState, useEffect} from "react";
import {useLocation} from "react-router-dom";
import {paperAirplane, GeneralPageTemplate} from "@pinch-financial/pinch-ui-components";
import {useTranslation} from "react-i18next";
import {Typography, Button} from "@mui/material";
import {faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import {sendMigrateEmail} from "~/api/auth";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
}

const MigrateConfirmationPage = ({containerRef}: Props) => {
  const {t: fixedT} = useTranslation("", {keyPrefix: "migrateConfirmationPage"});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const username = location.state?.username;

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [sentEmail, setSentEmail] = useState<boolean>(false);
  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      const {data, error} = await sendMigrateEmail(username);
      if (error) {
        setErrorMessage(fixedT("error")!);
        return;
      } else {
        setSentEmail(true);
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <GeneralPageTemplate ref={containerRef} navigationBar={<></>} iconSrc={paperAirplane}>
      <Typography variant="h1">{fixedT("title")}</Typography>
      <Typography mt={4} mb={4}>
        {sentEmail ? fixedT("submitted") : fixedT("message")}
      </Typography>
      <Typography color="red" mt={4} mb={4}>
        {errorMessage}
      </Typography>
      {!sentEmail && (
        <Button onClick={() => onSubmit()} disabled={isSubmitting} variant="contained">
          {isSubmitting ? (
            <>
              {fixedT("submitting")} <FontAwesomeIcon icon={faSyncAlt} spin={true} />
            </>
          ) : (
            fixedT("submit")
          )}
        </Button>
      )}
    </GeneralPageTemplate>
  );
};

export default MigrateConfirmationPage;
